import { useFaxV1QueryUpdaters } from './use-query-updaters';

export const useInvalidateFaxSearch = () => {
  const { invalidateQueries } = useFaxV1QueryUpdaters();

  return () => {
    invalidateQueries({
      endpointName: 'SearchFaxes',
    });
  };
};
